import { useMutation } from "@apollo/client/react";
import { toast } from 'react-hot-toast';
import { DELETE_ARCHIVO_VISITA } from '../../../data/graphQL/mutations/Visitas/deleteArchivoVisita.gql';

export const useDeleteArchivoVisita = () => {
  const [deleteArchivoVisitaMutation] = useMutation(DELETE_ARCHIVO_VISITA);

  const deleteArchivo = async ({ idArchivo, name, archivos, handleChange, hideToast = false }) => {
    try {
      const { data } = await deleteArchivoVisitaMutation({
        variables: { idArchivoVisita: idArchivo }
      });

      if (!hideToast && !data?.deleteArchivoVisita?.success) {
        return toast.error('No se pudo eliminar el archivo');
      }
      if (Array.isArray(archivos)) {
        const newFiles = archivos.filter((file) => file.idArchivo !== idArchivo);
        handleChange(name, newFiles);
      } else {
        handleChange(name, null);
      }

      if (!hideToast)
      toast.success('Archivo eliminado correctamente');
    } catch (error) {
      console.error(error);
      if (!hideToast) toast.error('Error al eliminar el archivo');
    }
  };

  return { deleteArchivo };
};